var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.99 20C16.5128 20 20.99 15.5228 20.99 10C20.99 4.47715 16.5128 0 10.99 0C5.46714 0 0.98999 4.47715 0.98999 10C0.98999 15.5228 5.46714 20 10.99 20Z",
    fill: "#234CE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5199 9.97C14.2299 9.68 13.7499 9.68 13.4599 9.97L11.7399 11.69V6.5C11.7399 6.09 11.3999 5.75 10.9899 5.75C10.5799 5.75 10.2399 6.09 10.2399 6.5V11.69L8.51993 9.97C8.22993 9.68 7.74993 9.68 7.45993 9.97C7.16993 10.26 7.16993 10.74 7.45993 11.03L10.4599 14.03C10.6099 14.18 10.7999 14.25 10.9899 14.25C11.1799 14.25 11.3699 14.18 11.5199 14.03L14.5199 11.03C14.8099 10.74 14.8099 10.26 14.5199 9.97Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon07);
export default __webpack_public_path__ + "static/media/chat-icon-07.7754b2e71564765840f3670107f13144.svg";
export { ForwardRef as ReactComponent };